import {
    getTokenRefresh,
    saveJwt,
    saveUser,
    tokenRefresh,
} from '../../../utils/authentication'

// renew tokens using fetch on signalR fail
export const updateAuthTokens = async () => {
    try {
        const refresh_token = getTokenRefresh() ?? ''
        const res = await fetch('/api/oauth/refresh_token', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ refresh_token }),
        })

        const tokens = await res?.json()

        if (tokens.access_token && tokens.refresh_token) {
            saveJwt(tokens.access_token)
            tokenRefresh(tokens.refresh_token)
            saveUser(tokens)
        }
        return tokens
    } catch (e: any) {
        console.error(e)
    }
}
